import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 代理店グループ-クロージングカテゴリー一覧取得
export async function getSaleCompanyGroupClosingCategorys(
  id: string,
  sale_company_id: string
) {
  try {
    const path = "saleCompanyGroupClosingCategorys";
    const params = { id, sale_company_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      categoryDatas: response.data.category_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 代理店グループ-クロージングカテゴリー一覧登録
export async function postSaleCompanyGroupClosingCategorys(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyGroupClosingCategorys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
